var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { key: _vm.timelineId, staticClass: "timeline" },
    [
      _c("timeline-navigation-bar", {
        ref: "navbar",
        staticClass: "navbar",
        attrs: {
          novelId: _vm.novelId,
          timelineType: _vm.timelineType,
          timelineId: _vm.timelineId,
          timelines: _vm.timelines,
          currentTimeline: _vm.timeline,
          isEditing: _vm.isEditing,
        },
        on: {
          showHistoryDialog: function ($event) {
            _vm.isHistoryManageDialogOpen = true
          },
        },
      }),
      _vm.isShowTable
        ? _c(
            "table",
            [
              !_vm.isPlot
                ? _c("timeline-chronology-header", {
                    attrs: {
                      timelineType: _vm.timelineType,
                      timelineId: _vm.timelineId,
                      headers: _vm.headers,
                      isEditing: _vm.isEditing,
                    },
                    on: { change: _vm.onChangeHeaders },
                  })
                : _c("timeline-plot-header", {
                    attrs: {
                      plotGroups: _vm.plotGroups,
                      isEditing: _vm.isEditing,
                    },
                  }),
              _c("timeline-body", {
                attrs: {
                  novelId: _vm.novelId,
                  timelineType: _vm.timelineType,
                  timelineId: _vm.timelineId,
                  headers: _vm.headersRemovedTimelineType,
                  bodies: _vm.bodies,
                  isEditing: _vm.isEditing,
                  isPlot: _vm.isPlot,
                },
                on: { change: _vm.onChangeBodies },
              }),
              !_vm.isEditing
                ? _c("button-round", { on: { click: _vm.onClickEdit } }, [
                    _vm._v(_vm._s(_vm.$t("common.edit"))),
                  ])
                : _c(
                    "button-round",
                    {
                      attrs: { icon: require("@/assets/img/icon/save.svg") },
                      on: { click: _vm.onClickSave },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.save")))]
                  ),
            ],
            1
          )
        : _c("div", { staticClass: "description" }, [
            _c("div", [
              _vm._v(_vm._s(_vm.$t("timelinePage.selectOrCreatePrompt"))),
            ]),
            _c(
              "button",
              { staticClass: "button", on: { click: _vm.onClickAdd } },
              [_vm._v(_vm._s(_vm.$t("timelinePage.createNew")))]
            ),
          ]),
      _vm.timeline && _vm.timelineId
        ? _c("history-manage-dialog", {
            attrs: {
              "is-open": _vm.isHistoryManageDialogOpen,
              "data-type": "timeline",
              title: _vm.historyDialogTitle,
              "novel-id": _vm.novelId,
              "data-id": _vm.timelineId,
            },
            on: {
              close: function ($event) {
                _vm.isHistoryManageDialogOpen = false
              },
              restore: _vm.onTimelineRestore,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "notification",
                  fn: function () {
                    return [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              "historyManageDialog.notification.plotNotUpdated"
                            )
                          ) +
                          " "
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "content",
                  fn: function ({ historyItem }) {
                    return [
                      historyItem
                        ? _c(
                            "div",
                            { staticClass: "timeline-history-preview" },
                            [
                              _c(
                                "table",
                                { staticClass: "history-preview-table" },
                                [
                                  !_vm.isPlot
                                    ? _c("timeline-chronology-header", {
                                        staticClass: "history-preview-header",
                                        attrs: {
                                          timelineType:
                                            historyItem.item.timelineType,
                                          timelineId: "",
                                          headers: _vm.getHistoryPreviewHeaders(
                                            historyItem
                                          ),
                                          isEditing: false,
                                        },
                                      })
                                    : _c("timeline-plot-header", {
                                        staticClass: "history-preview-header",
                                        attrs: {
                                          plotGroups: _vm.plotGroups,
                                          isEditing: false,
                                        },
                                      }),
                                  _c("timeline-body", {
                                    attrs: {
                                      novelId: _vm.novelId,
                                      timelineType:
                                        historyItem.item.timelineType,
                                      timelineId: "",
                                      headers: _vm.getHistoryBodyHeaders(
                                        historyItem
                                      ),
                                      bodies: historyItem.item.tableBodies,
                                      isEditing: false,
                                      isPlot: _vm.isPlot,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  },
                },
              ],
              null,
              false,
              690043971
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }